import React from 'react';
import { useDebouncedValue } from '@deephaven/react-hooks';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Display a modal after a debounce time. Blocks the screen from interaction immediately,
 * but then waits the set debounce time before rendering the modal.
 */
function DebouncedModal(_ref) {
  var _ref$blockInteraction = _ref.blockInteraction,
    blockInteraction = _ref$blockInteraction === void 0 ? true : _ref$blockInteraction,
    children = _ref.children,
    debounceMs = _ref.debounceMs,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;
  var _useDebouncedValue = useDebouncedValue(isOpen, debounceMs),
    debouncedIsOpen = _useDebouncedValue.value;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [blockInteraction && isOpen && /*#__PURE__*/_jsx("div", {
      className: "modal-backdrop",
      style: {
        backgroundColor: 'transparent'
      },
      "data-testid": "debounced-modal-backdrop"
    }), /*#__PURE__*/React.cloneElement(children, {
      isOpen: isOpen && debouncedIsOpen
    })]
  });
}
export default DebouncedModal;
//# sourceMappingURL=DebouncedModal.js.map